import { SPORTS, type Sport } from "@/pages/Home/constant";
import { cn } from "@roman/shared/utils";

type SelectSportProps = {
  selectedSport: Sport;
  setSelectedSport: (sport: Sport) => void;
};

const SelectSport: React.FC<SelectSportProps> = ({ selectedSport, setSelectedSport }) => {
  return (
    <div className="flex pt-[15px] justify-center">
      <div className="flex justify-around w-full items-center">
        {SPORTS.map((sport) => (
          <div
            className="flex items-center hover:cursor-pointer"
            onClick={() => setSelectedSport(sport)}
            key={sport.id}
          >
            <span className="bg-button-background p-1.5 rounded-3xl">
              <sport.icon className={cn(selectedSport.id === sport.id ? "text-primary" : "text-[#5C5C5C]")} />
            </span>
            <span className={cn(selectedSport.id === sport.id ? "text-primary font-bold" : "text-[#5C5C5C]")}>
              {sport.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectSport;
